import script from "./manage-imports.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-imports.vue?vue&type=script&setup=true&lang=js"

import "./manage-imports.vue?vue&type=style&index=0&id=78b9fb95&lang=scss"

const __exports__ = script;

export default __exports__